import { DaycareId } from '../../replicant/daycare';

export const daycareIcons: Record<DaycareId, string> = {
  d_daycare_6h: 'assets/ui/daycare/icons/daycare_option_6h.png',
};
